module.exports = __webpack_public_path__ + "static/legacy_honor_bg-7f5cd1288cb785a51b99b2571cee31ea.jpg";